// removed by extract-text-webpack-plugin
module.exports = {"Heading":"_yuwE4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Headers/SearchResultHeader/SearchResultMobileHeading/SearchResultMobileHeading.scss
// module id = 717
// module chunks = 0